export enum Constant {
  TOKEN_KEY = 'token',
}
